import React from 'react';

export class FailedUi extends React.PureComponent<{error?: Error}, {}> {

    render(){
        return (
            <div className="error-info">
                <div className="error-title">
                    Whoops!
                </div>
                <div className="error-description">
                    {this.props.error?.message}
                </div>
                <div className="error-action">
                    <button onClick={() => window.location.reload()}>Reload page</button>
                </div>
            </div>
        );
    }
}